import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sid });
        setUser(res.data);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        const msg =
          e?.response?.status === 403
            ? e?.response?.data?.detail || "This account isn't authorized. Contact the coach for access."
            : "";
        navigate(msg ? `/login?error=${encodeURIComponent(msg)}` : "/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#050505] text-white">
      <div className="h-16 w-16 rounded-full border-2 border-cyan-400/30 border-t-cyan-400 animate-spin" />
      <p className="mt-6 font-tac text-xs tracking-[0.3em] txt-cyan">SYNCING WITH AVA MOTHERSHIP…</p>
    </div>
  );
}
